/* Catalog / collection page (PLP) — INXL World.
 * Client-side filtering + sorting, mirroring the Woo FilterBar:
 *   • Category (data-type), Artist (data-vendor), Size (data-sizes), Price bucket
 *     (data-price). Multi-select within a group = OR; across groups = AND.
 *   • Sort: default (collection order) / newest / price asc / price desc.
 * Dropdowns toggle a popover; outside-click closes. Live count + per-filter
 * badges + a Reset button + empty state. Early-returns off the PLP.
 */
(function () {
  var root = document.querySelector('[data-plp]');
  if (!root) return;
  var grid = root.querySelector('[data-plp-grid]');
  var cells = Array.prototype.slice.call(root.querySelectorAll('[data-plp-cell]'));
  if (!grid || !cells.length) return;
  var totalEl = root.querySelector('[data-plp-total]');
  var emptyEl = root.querySelector('[data-plp-empty]');
  var resetBtn = root.querySelector('[data-plp-reset]');
  var filters = Array.prototype.slice.call(root.querySelectorAll('[data-plp-filter]'));
  var originalOrder = cells.slice();

  var selected = { type: new Set(), vendor: new Set(), size: new Set(), price: new Set() };
  var sortMode = 'default';
  var LIMIT_STEP = 10;      // Woo shows 10, "Show more" reveals +10 at a time
  var limit = LIMIT_STEP;
  var currentOrder = cells.slice();
  var moreBtn = root.querySelector('[data-plp-more]');

  function priceBucket(cents) {
    var e = (cents || 0) / 100;
    if (e < 20) return 'lt-20';
    if (e <= 50) return '20-50';
    if (e <= 100) return '50-100';
    return 'gt-100';
  }

  function matchesCategory(cell, values) {
    var categories = (cell.getAttribute('data-type') || '').split(',').filter(Boolean);
    return Array.from(values).some(function (value) { return categories.indexOf(value) !== -1; });
  }

  function cellMatches(cell) {
    if (selected.type.size && !matchesCategory(cell, selected.type)) return false;
    if (selected.vendor.size && !selected.vendor.has(cell.getAttribute('data-vendor'))) return false;
    if (selected.size.size) {
      var cs = (cell.getAttribute('data-sizes') || '').split(',').filter(Boolean);
      var ok = false;
      selected.size.forEach(function (s) { if (cs.indexOf(s) !== -1) ok = true; });
      if (!ok) return false;
    }
    if (selected.price.size && !selected.price.has(priceBucket(parseInt(cell.getAttribute('data-price'), 10)))) return false;
    return true;
  }

  // For dead-end pruning: would any cell match if group `key` were `val`, combined
  // with the OTHER groups' current selections?
  function matchesExcept(cell, key, val) {
    if (key !== 'type' && selected.type.size && !matchesCategory(cell, selected.type)) return false;
    if (key !== 'vendor' && selected.vendor.size && !selected.vendor.has(cell.getAttribute('data-vendor'))) return false;
    if (key !== 'size' && selected.size.size) {
      var cs = (cell.getAttribute('data-sizes') || '').split(',').filter(Boolean);
      var ok = false;
      selected.size.forEach(function (s) { if (cs.indexOf(s) !== -1) ok = true; });
      if (!ok) return false;
    }
    if (key !== 'price' && selected.price.size && !selected.price.has(priceBucket(parseInt(cell.getAttribute('data-price'), 10)))) return false;
    if (key === 'type') return matchesCategory(cell, [val]);
    if (key === 'vendor') return cell.getAttribute('data-vendor') === val;
    if (key === 'size') { var c2 = (cell.getAttribute('data-sizes') || '').split(',').filter(Boolean); return c2.indexOf(val) !== -1; }
    if (key === 'price') return priceBucket(parseInt(cell.getAttribute('data-price'), 10)) === val;
    return true;
  }
  // Dim filter options that would yield zero results given the other active filters.
  function prune() {
    filters.forEach(function (f) {
      var key = f.getAttribute('data-plp-filter');
      f.querySelectorAll('input[data-plp-value]').forEach(function (input) {
        var val = input.getAttribute('data-plp-value');
        var any = cells.some(function (cell) { return matchesExcept(cell, key, val); });
        var label = input.closest('.plp__opt');
        if (label) label.classList.toggle('is-disabled', !any && !input.checked);
      });
    });
  }

  function apply() {
    // Count ALL matches but only display the first `limit` (in current sort
    // order); "Show more" raises `limit`. Total label still shows all matches.
    var matched = 0;
    currentOrder.forEach(function (cell) {
      if (cellMatches(cell)) {
        matched++;
        cell.hidden = matched > limit;
      } else {
        cell.hidden = true;
      }
    });
    if (totalEl) totalEl.textContent = matched;
    if (emptyEl) emptyEl.hidden = matched !== 0;
    if (moreBtn) moreBtn.hidden = matched <= limit;
    var any = selected.type.size || selected.vendor.size || selected.size.size || selected.price.size;
    if (resetBtn) resetBtn.hidden = !any;
    filters.forEach(function (f) {
      var key = f.getAttribute('data-plp-filter');
      var badge = f.querySelector('[data-plp-count-badge]');
      var n = selected[key] ? selected[key].size : 0;
      if (badge) { badge.textContent = n; badge.hidden = n === 0; }
    });
    prune();
  }

  function sortCells() {
    var arr = originalOrder.slice();
    if (sortMode === 'newest') arr.sort(function (a, b) { return (+b.getAttribute('data-created')) - (+a.getAttribute('data-created')); });
    else if (sortMode === 'price-asc') arr.sort(function (a, b) { return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price')); });
    else if (sortMode === 'price-desc') arr.sort(function (a, b) { return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price')); });
    arr.forEach(function (c) { grid.appendChild(c); });
    currentOrder = arr;
    limit = LIMIT_STEP; // re-sorting resets the progressive reveal
    apply();
  }

  // ---- Filter/sort state <-> URL (shareable, refresh-safe; replaceState so
  //      it doesn't spam browser history on every checkbox). ----
  var GROUPS = ['type', 'vendor', 'size', 'price'];
  function writeUrl() {
    var params = new URLSearchParams();
    GROUPS.forEach(function (k) {
      if (selected[k].size) params.set(k, Array.from(selected[k]).join(','));
    });
    if (sortMode !== 'default') params.set('sort', sortMode);
    var qs = params.toString();
    try { history.replaceState(null, '', qs ? ('?' + qs) : window.location.pathname); } catch (e) {}
  }
  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (k) {
      var v = params.get(k);
      if (v) v.split(',').forEach(function (val) { if (val) selected[k].add(val); });
    });
    var s = params.get('sort');
    if (s) sortMode = s;
    root.querySelectorAll('input[data-plp-value]').forEach(function (input) {
      var f = input.closest('[data-plp-filter]');
      if (!f) return;
      var key = f.getAttribute('data-plp-filter');
      if (selected[key] && selected[key].has(input.getAttribute('data-plp-value'))) input.checked = true;
    });
    if (sortWrap && sortMode !== 'default') {
      sortWrap.querySelectorAll('[data-plp-sort-value]').forEach(function (o) {
        var on = o.getAttribute('data-plp-sort-value') === sortMode;
        o.classList.toggle('is-active', on);
        if (on && sortLabelEl) sortLabelEl.textContent = o.textContent;
      });
    }
  }

  // ---- Dropdown open/close ----
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-plp-chip]'));
  function closeAll(except) {
    chips.forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var pop = btn.parentElement.querySelector('[data-plp-pop]');
      if (pop) pop.hidden = true;
    });
  }
  chips.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var pop = btn.parentElement.querySelector('[data-plp-pop]');
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeAll(btn);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (pop) pop.hidden = open;
    });
  });
  root.querySelectorAll('[data-plp-pop]').forEach(function (pop) {
    pop.addEventListener('click', function (e) { e.stopPropagation(); });
  });
  document.addEventListener('click', function () { closeAll(null); });

  // ---- Checkboxes ----
  filters.forEach(function (f) {
    var key = f.getAttribute('data-plp-filter');
    f.querySelectorAll('input[data-plp-value]').forEach(function (input) {
      input.addEventListener('change', function () {
        var val = input.getAttribute('data-plp-value');
        if (input.checked) selected[key].add(val); else selected[key].delete(val);
        limit = LIMIT_STEP;
        apply();
        writeUrl();
      });
    });
  });

  // ---- Sort ----
  var sortWrap = root.querySelector('[data-plp-sort]');
  if (sortWrap) {
    var sortLabelEl = sortWrap.querySelector('[data-plp-sort-label]');
    sortWrap.querySelectorAll('[data-plp-sort-value]').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        sortMode = opt.getAttribute('data-plp-sort-value');
        sortWrap.querySelectorAll('[data-plp-sort-value]').forEach(function (o) { o.classList.toggle('is-active', o === opt); });
        if (sortLabelEl) sortLabelEl.textContent = opt.textContent;
        closeAll(null);
        sortCells();
        writeUrl();
      });
    });
  }

  // ---- Reset ----
  if (resetBtn) resetBtn.addEventListener('click', function () {
    Object.keys(selected).forEach(function (k) { selected[k].clear(); });
    root.querySelectorAll('input[data-plp-value]').forEach(function (i) { i.checked = false; });
    limit = LIMIT_STEP;
    apply();
    writeUrl();
  });

  // ---- Show more (progressive reveal) ----
  if (moreBtn) moreBtn.addEventListener('click', function () {
    limit += LIMIT_STEP;
    apply();
  });

  readUrl();
  sortCells();
})();
